import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <div className="gold-line"></div>
            <h2 className="hero-title">Elevate Your Standards with NQC</h2>
            <p className="hero-intro">
              At NQC, we are dedicated to helping businesses achieve excellence through our comprehensive certification solutions.
            </p>
            <p className="hero-description">
              With our expert team and commitment to quality, we ensure that your products and processes meet and exceed industry standards. Whether it's obtaining ISO certification, ensuring CE marking compliance, or enhancing food safety with FSSC 22000, we provide the expertise and support needed to navigate the complexities of certification. Partner with NQC to elevate your standards and gain a competitive edge in the global market.
            </p>
          </div>
          <div className="hero-image">
            <img 
              src="/assets/images/5.jpg" 
              alt="NQC Certification Services"
              onError={(e) => {
                // 5.jpg yoksa hero-image.jpg dene
                if (e.target.src.includes('5.jpg')) {
                  e.target.src = '/assets/images/hero-image.jpg';
                  return;
                }
                // hero-image.jpg yoksa PNG dene
                if (e.target.src.includes('.jpg')) {
                  e.target.src = '/assets/images/hero-image.png';
                  return;
                }
                // PNG yoksa farklı isimlerle dene
                if (e.target.src.includes('hero-image.png')) {
                  e.target.src = '/assets/images/business-meeting.jpg';
                  return;
                }
                if (e.target.src.includes('business-meeting.jpg')) {
                  e.target.src = '/assets/images/business-meeting.png';
                  return;
                }
                // Hiçbiri yoksa placeholder göster
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div className="hero-image-placeholder" style={{display: 'none'}}>
              <span>Business Meeting Image</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

